import React, { useEffect, useState, useRef } from 'react';
import { useTable, useGlobalFilter, useFilters, usePagination, useSortBy } from 'react-table';
import { GlobalFilter } from '../table/FilteringTable/GlobalFilter';
import { SidPagination } from './SidPagination';
import { listStateKey, readListState, writeListState } from './listState';
import { PageHeaderActions, usePageHeaderActionsSlot } from './pageHeaderActions';
import { Button, Modal } from "react-bootstrap";
import { Link } from 'react-router-dom';
import { Add, FilterSquare } from 'iconsax-react';
import './filtering.css';

import { useFiltriSullaRiga } from './useFiltriSullaRiga';
export const TabellaLista = (props) => {

	const [data, setDataJson] = useState([]);
	// Ricerca e filtri sulla stessa riga: prima si stringe la ricerca, poi i tasti (useFiltriSullaRiga)
	const rigaFiltri = useRef(null);
	useFiltriSullaRiga(rigaFiltri);
	const [columns, setColumns] = useState([]);
	const [message, setMessage] = useState('Caricamento in corso...');

	// Il testo cercato si ricorda per pagina e lista (vedi listState)
	const searchKey = listStateKey(props.cardTitle || '', 'ricerca');
	const [initialSearch] = useState(() => readListState(searchKey));

	const tableInstance = useTable({
		columns,
		data,
		// Il testo cercato resta anche quando i dati cambiano (filtri esterni, ricarica dopo un salvataggio)
		autoResetGlobalFilter: false,
		initialState: { 
			pageIndex: 0,
			globalFilter: initialSearch,
			sortBy: [
				{
					id: props.sort_by,
					desc: (props.sort_type === 'desc')
				}
			]
		}
	}, useFilters, useGlobalFilter, useSortBy, usePagination)

	const {
		getTableProps,
		getTableBodyProps,
		headerGroups,
		prepareRow,
		state,
		rows,
		page,
		gotoPage,
		pageOptions,
		nextPage,
		previousPage,
		canNextPage,
		canPreviousPage,
		setGlobalFilter,
	} = tableInstance

	const { globalFilter, pageIndex } = state

	useEffect(() => {
		writeListState(searchKey, globalFilter);
	}, [searchKey, globalFilter]);

	const [show, setShow] = useState(false);
	const [modalStyle, setModalStyle] = useState({
		position: 'fixed',
		margin: 0,
		top: 0,
		right: '-100%',
		height: '100%',
		transition: 'right 0.5s ease-in-out',
		visibility: 'hidden' // Inizialmente nascondi la modale
	});

	const handleShow = () => {
		setShow(true);
	};

	const handleClose = () => {
		setModalStyle(prevStyle => ({
			...prevStyle,
			right: '-100%',
			visibility: 'hidden' // Nascondi la modale
		}));
		setShow(false);
	};

	useEffect(() => {
		if (show) {
			setTimeout(() => {
				setModalStyle(prevStyle => ({
					...prevStyle,
					right: 0,
					visibility: 'visible' // Rendi visibile la modale
				}));
			}, 300);
		}
	}, [show]);

	useEffect(() => {
		setColumns(props.data_column);

		if(props.data_json) {
			setDataJson(props.data_json);
			setMessage('Nessun dato presente');
		} else {
			setMessage('Caricamento in corso');
		}
	}, [props]);

	const headerSlot = usePageHeaderActionsSlot(props.pageList);
	const actionButtons = (
		<>
			{props.hasAddMore && props.linkAddMore && <Link to={props.linkAddMore} className="btn btn-primary btn-sm btn-add"> <Add variant="Bulk" /><span className='ms-2'>{props.labelAddMore}</span></Link>}
			{props.hasAddMoreAsModal && <Button onClick={props.modalCallBack} className="btn btn-primary btn-sm btn-add" ><Add variant="Bulk" /><span className='ms-2'>{props.labelAddMore || 'Aggiungi'}</span></Button>}
			{props.headerButtons}
		</>
	);


	// Riga apribile (props.openRow): in fondo una colonna stretta con la freccia, solo come segnale
	// che il clic porta alla scheda. Il clic resta della riga intera.
	const conFreccia = !!props.openRow;
	const numColonne = props.data_column.length + (conFreccia ? 1 : 0);
	return (
		<>
			<div className="card">
				<div className="card-header sid-list-header">
					{/* Lista principale della pagina: titolo e pulsanti stanno sopra il box (SidPageHeader) */}
					{props.pageList ? (
						<PageHeaderActions slot={headerSlot}>{actionButtons}</PageHeaderActions>
					) : (props.cardTitle || props.hasFilter || (props.hasAddMore && props.linkAddMore) || props.hasAddMoreAsModal || props.headerButtons) && (
					<div className="sid-list-header__top">
						<h4 className="card-title">{props.cardTitle}</h4>
						<div className="sid-list-header__actions">
							{props.hasFilter && <Button onClick={handleShow} className="btn btn-dark light btn-sm btn-add"><span className='me-2'>Filtri</span><FilterSquare variant="Bulk" /></Button>}
							{actionButtons}
						</div>
					</div>
					)}
					{(props.hasSearch || props.filterControl) && (
						<div className="sid-list-header__bottom" ref={rigaFiltri}>
							{props.hasSearch && <GlobalFilter filter={globalFilter} setFilter={setGlobalFilter} placeholder={props.searchPlaceholder} />}
							{props.filterControl && <div className="sid-list-header__filter">{props.filterControl}</div>}
						</div>
					)}
				</div>
				<div className="card-body">
					<div className="table-responsive" style={{ overflowX: 'auto' }}>
						<table {...getTableProps()} className="table dataTable display">
							<thead>
								{headerGroups.map(headerGroup => (
									<tr {...headerGroup.getHeaderGroupProps()}>
										{headerGroup.headers.map((column, index, array) => (
											<th key={column.id} {...column.getHeaderProps(column.getSortByToggleProps())} className={[column.compact ? 'sid-col-compact' : '', column.align === 'center' ? 'text-center' : ''].filter(Boolean).join(' ') || undefined}
												style={column.larghezza ? { width: column.larghezza, minWidth: column.larghezza } : undefined}>
												{column.render('Header')}
												{column.canSort && (conFreccia ? (column.id !== 'azione' && column.Header !== 'Azione') : index !== array.length - 1) && (
													<span className="ms-2 sid-sort-ico">
														{column.isSorted
															? (column.isSortedDesc ? <i className="fa fa-arrow-down fs-14" /> : <i className="fa fa-arrow-up fs-14" />)
															: <i className="fa fa-sort fs-14" />}
													</span>
												)}
											</th>
										))}
										{conFreccia && <th className="sid-col-arrow" aria-hidden="true" />}
									</tr>
								))}
							</thead>
							<tbody {...getTableBodyProps()} className="">
								{/* Riquadro in testa alla tabella (es. «Nuovo traguardo» aperto sul posto) */}
								{props.topPanel && (
									<tr className="sid-row-panel">
										<td colSpan={numColonne}>{props.topPanel}</td>
									</tr>
								)}
								{page.length === 0 ? (
									<tr>
										<td colSpan={numColonne} style={{ textAlign: 'center' }}>
											{message}
										</td>
									</tr>
								) : (
									page.map((row) => {
										prepareRow(row);
										// Riga intera cliccabile: apre la scheda come "Visualizza" nel menu azioni.
										// I clic su pulsanti, menu, link e campi dentro la riga fanno la loro azione.
										const apribile = props.openRow && (!props.canOpenRow || props.canOpenRow(row.original));
										const apri = (e) => {
											if (e.target.closest('button, a, input, select, textarea, label, .dropdown, .dropdown-menu, [role="menu"]')) return;
											props.openRow(row.original);
										};
										// Riquadro di dettaglio subito sotto la riga (props.rowPanel): se c'e' la riga resta evidenziata
										const pannello = props.rowPanel ? props.rowPanel(row.original) : null;
										return (
											<React.Fragment key={row.getRowProps().key}>
											<tr
												{...row.getRowProps()}
												className={[apribile ? 'sid-row-link' : '', pannello ? 'is-open' : ''].filter(Boolean).join(' ') || undefined}
												onClick={apribile ? apri : undefined}
												onKeyDown={apribile ? (e) => { if (e.key === 'Enter' && e.target === e.currentTarget) props.openRow(row.original); } : undefined}
												tabIndex={apribile ? 0 : undefined}
											>
												{row.cells.map((cell) => (
													<td
														{...cell.getCellProps()}
															data-label={typeof cell.column.Header === 'string' ? cell.column.Header : undefined}
														className={[apribile && cell.column.id === props.openColumn ? 'sid-row-link__name' : '', cell.column.compact ? 'sid-col-compact' : '', cell.column.align === 'center' ? 'text-center' : ''].filter(Boolean).join(' ') || undefined}
													> {cell.render('Cell')} </td>
												))}
												{conFreccia && (
													<td className="sid-col-arrow" aria-hidden="true">
														{apribile && <i className={`fa ${pannello ? 'fa-chevron-down' : 'fa-chevron-right'}`} />}
													</td>
												)}
											</tr>
											{pannello && (
												<tr className="sid-row-panel">
													<td colSpan={numColonne}>{pannello}</td>
												</tr>
											)}
											</React.Fragment>
										);
									})
								)}
							</tbody>
						</table>

						<div className="d-flex align-items-center justify-content-between footTab">
							{/* Totale degli elementi in lista, dopo ricerca e filtri */}
							{props.data_json ? <span className="sid-list-total">{rows.length === 1 ? '1 elemento' : `${rows.length} elementi`}</span> : <span />}
							{!props.notPagination && pageOptions.length > 0 &&
								<SidPagination
									pageIndex={pageIndex}
									pageCount={pageOptions.length}
									gotoPage={gotoPage}
									previousPage={previousPage}
									nextPage={nextPage}
									canPreviousPage={canPreviousPage}
									canNextPage={canNextPage}
								/>
							}
						</div>
					</div>
				</div>
			</div>
			{show && (
				<Modal show={show} onHide={handleClose}>
					<div className="modal-dialog" style={modalStyle}>
						<div className="modal-content" style={{ height: '100%', border: 'none', borderRadius: 0 }}>
							<Modal.Header closeButton>
								<Modal.Title>Filtri</Modal.Title>
							</Modal.Header>
							<Modal.Body style={{ overflowY: 'auto' }}>
								{headerGroups.map(headerGroup => (
									<div {...headerGroup.getHeaderGroupProps()}>
										{headerGroup.headers.map(column => (
											column.canFilter && (
												<span key={column.id} {...column.getHeaderProps()}>
													{column.render('Header')}
													{column.canFilter && column.render('Filter')}
												</span>
											)
										))}
									</div>
								))}
							</Modal.Body>
							<Modal.Footer>
								<Button variant="secondary" onClick={handleClose}>
									Chiudi
								</Button>
							</Modal.Footer>
						</div>
					</div>
				</Modal>
			)}

			{props.modalContent && props.modalContent}
		</>
	)

}
export default TabellaLista;